import { CommonProps } from './common-props';
export default {
  props: CommonProps,
  computed: {
    topList() {
      var tempList = this.rankList.slice(0, 3);
      while (tempList.length < 3) {
        tempList.push(null);
      }
      var [gold, silver, bronze] = tempList;
      return [{
        data: silver,
        className: 'tp2'
      }, {
        data: gold,
        className: 'tp1'
      }, {
        data: bronze,
        className: 'tp3'
      }];
    },
    normalList() {
      var startIdx = this.highlightTop3 ? 3 : 0;
      return this.rankList.slice(startIdx);
    },
    itemUnit() {
      return this.showPointUnit ? this.unit : '';
    },
    hasOwn() {
      return this.own && (Object.keys(this.own).length > 0 || Array.isArray(this.own) && this.own.length > 0);
    },
    selfShowEmptyText() {
      if (typeof this.showEmptyText === 'boolean') {
        return this.showEmptyText;
      }
      if (typeof this.showEmptyText === 'function') {
        return this.showEmptyText({
          normalList: this.normalList,
          topList: this.topList,
          rankList: this.rankList
        });
      }
    }
  }
};